export const BASKETBALL = "basketball";
export const BASEBALL = "baseball";
export const FOOTBALL = "football";
export const SPORTS_ARRAY = [BASKETBALL, BASEBALL, FOOTBALL];

export const HIGH_TO_LOW = "highToLow";
export const LOW_TO_HIGH = "lowToHigh";

export const GLOBAL_VARIABLES = "globalVariables";
export const ERA_0 = "demo-era";
export const ERA_1 = "era1";

export const NUMBER_OF_TEAMS = 16;
export const STARTING_YEAR_SUPPLEMENTAL_DRAFT_PICKS = 2025;

export const ALPHABET = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
];
